export default __webpack_public_path__ + "static/media/edward_lee.d6ccfa73.jpg";